<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5
    
    .titulo-principal.color-acento-contenido
      .titulo-principal__numero.text-white
        span 3
      h1 Validación de la propuesta técnica
    

    .row.justify-content-center.mb-5
      .col-lg-6.mb-4.mb-lg-0.ontop.pt-lg-4
        
        .bg--blue.neg--right.mb-4(style='background-color: #F3F9FF;')
          p.mb-0 La comprobación y análisis de la propuesta de servicio de <em>software</em> estará mediada y determinada por aspectos relativos a la normatividad, a la contratación y/o licitación, a las garantías de efectividad de la propuesta misma, entre otros.
          
        p.mb-4 A continuación, le presentamos los elementos más relevantes que afectan directamente el proceso de validación de una propuesta técnica:
        
      .col-10.col-lg-6
        figure(data-aos="fade-left")
          img.mx-auto(src='@/assets/curso/tema3/img1.png', alt='imagen ambiental', style='width: 600px;')
    


    .row.justify-content-center.mb-5
      .col-lg-12.mb-4
        .fondo--slider
          SlyderE(indicadores="centro")
            .row.justify-content-center
              .col-md-6.mb-4.mb-md-0.align-self-center
                h4 Contratación
                p.mb-0 Se realiza después que el cliente haya aceptado una de las propuestas técnicas presentadas, o que al ofertante le hayan adjudicado una licitación; para legalizar este trámite es necesario cerrar el acuerdo por medio de un contrato escrito, en el cual estén estipulados todos los términos y condiciones que se acordaron en la propuesta técnica o en el pliego de condiciones. 
                
              .col-10.col-md-6
                figure
                  img.mx-auto(src='@/assets/curso/tema3/img2.svg', alt='imagen ambiental', style='width: 500px;')
                  
            .row.justify-content-center
              .col-md-6.mb-4.mb-md-0.align-self-center
                h4 Fundamentos
                p.mb-0 El fin de los principios o fundamentos, en contratación, es garantizar a los ciudadanos un proceso público transparente y con igualdad, al que pueden acceder todas las personas o empresas que cumplan con los requisitos establecidos en un pliego de condiciones publicado por las entidades estatales, que pueden ser SENA, DIAN, Fuerzas Militares, ICBF, DANE, universidades, alcaldías, gobernaciones, etc.
                
              .col-10.col-md-6
                figure
                  img.mx-auto(src='@/assets/curso/tema3/img3.svg', alt='imagen ambiental', style='width: 500px;')
                  
            .row.justify-content-center
              .col-md-6.mb-4.mb-md-0.align-self-center
                h4 Contratación privada
                p.mb-0 Se trata del acuerdo al que llegan dos partes que pueden ser personas naturales o jurídicas para que se haga un producto,  una labor o se deje de hacer algo, en este documento se pactan términos, acuerdos, multas y la forma de remuneración económica.
                
              .col-10.col-md-6
                figure
                  img.mx-auto(src='@/assets/curso/tema3/img4.svg', alt='imagen ambiental', style='width: 500px;')
                  
            .row.justify-content-center
              .col-md-6.mb-4.mb-md-0.align-self-center
                h4 Contratación pública o estatal
                p.mb-0 Según el artículo 3 de la Ley 80 de 1993, la contratación estatal tiene como fin, “la continua y eficiente prestación de los servicios públicos y la efectividad de los derechos e intereses de los administrados que colaboran con ellas, en la consecución de dichos fines”; el Estado contrata particulares para el cumplimiento de sus fines.
                
              .col-10.col-md-6
                figure
                  img.mx-auto(src='@/assets/curso/tema3/img5.svg', alt='imagen ambiental', style='width: 500px;')
                  
            .row.justify-content-center
              .col-md-6.mb-4.mb-md-0.align-self-center
                h4 La licitación
                p.mb-0 Método por el cual una entidad del Estado otorga un servicio u obra a una empresa o persona que ofrece las mejores condiciones. La licitación 
                  b es privada, 
                  b-none cuando solo pueden participar las empresas a las cuales se hayan enviado invitaciones. 
                  b Es pública, 
                  b-none cuando se abre a todos los participantes, cualquier persona puede participar en el proceso.
                
              .col-10.col-md-6
                figure
                  img.mx-auto(src='@/assets/curso/tema3/img6.svg', alt='imagen ambiental', style='width: 500px;')
                  
            
            
            


    #t_3_1.titulo-segundo.color-acento-contenido
      .h2 3.1 Aspectos de la contratación por licitación
    


    .row.justify-content-center.mb-5
      .col-lg-6.mb-4.mb-lg-0.ontop.pt-lg-3
        
        .bg--blue.neg--right.mb-4(style='background-color: #FFF9E5')
          p.mb-0 En Colombia existen dos tipos de contratación: la privada y la pública o estatal. Cada uno de estos tipos de contratación tiene sus particularidades y aspectos normativos y legales.
          
        p.mb-4 Los requisitos que se deben cumplir a nivel personal o empresarial, según corresponda, para una participación legítima en una licitación estatal son:
          
        .row.justify-content-center.mb-4
          .col-md-10
            ul.lista-ul.ps-md-0
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Contar con RUT Registro Único Tributario, “lo expide la DIAN”.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Tener la empresa inscrita en registro mercantil “Gestione en Cámara de Comercio”.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Tener registrada la empresa o trabajadores a una ARL “Administradora de Riesgos Laborales”.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Llevar la contabilidad de la empresa según la Guía Técnica 184 “Apoyo de un Contador Público”.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Los trabajadores de la empresa deben estar afiliados al sistema de seguridad social “Salud, pensión y caja de compensación”.
              
      .col-10.col-lg-6
        figure(data-aos="fade-left")
          img.mx-auto(src='@/assets/curso/tema3/img7.svg', alt='imagen ambiental', style='width: 610px;')


    p.mb-5  El proceso de licitación pública tiene algunos pasos de estricto cumplimiento, que usted puede conocer, explorando el siguiente recurso:

              
    .row.justify-content-center
      .col-lg-8
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/tema3/img8.svg' alt='AvatarTop')
          .tarjeta.tarjeta--azul
            .p-4
              h4 Pliego de condiciones
              p.mb-0 La entidad estatal requiere obras, bienes o servicios; elabora plan de compras el cual debe ser aprobado. Elabora y publica (10 días hábiles) 
                b pliego de condiciones 
                b-none “Borrador” en la página SECOP https://colombiacompra.gov.co/., aunque también se publica por la página web de la entidad.
              
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/tema3/img9.svg' alt='AvatarTop')
          .tarjeta.tarjeta--azul
            .p-4
              h4 Proponentes u oferentes
              p.mb-0 Las personas interesadas “también llamadas 
                b Proponentes u Oferentes” 
                b-none en el término de los 10 días hábiles pueden solicitar si es necesario, aclaraciones del pliego de condiciones. Con la resolución de apertura del proceso el cual incluye el cronograma de presentación de propuestas (Publicación del pliego de condiciones definitivo).
              
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/tema3/img10.svg' alt='AvatarTop')
          .tarjeta.tarjeta--azul
            .p-4
              h4 Entrega de propuestas
              p.mb-0 La audiencia de asignación, revisión y distribución de riesgos es realizada por la entidad para que los futuros proponentes aclaren sus dudas y realicen observaciones sobre el proceso. Conforme al cronograma los proponentes 
                b entregarán sus propuestas 
                b-none en el lugar, hora y en los términos señalados.
              
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/tema3/img11.svg' alt='AvatarTop')
          .tarjeta.tarjeta--azul
            .p-4
              h4  Etapa de evaluación
              p.mb-0 La entidad inicia la verificación de los requisitos mínimos y se otorgan los puntajes de las ofertas presentadas. La entidad presenta el informe de la evaluación, por un término de cinco días hábiles. Los oferentes pueden pronunciarse y presentar observaciones.
              
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/tema3/img12.svg' alt='AvatarTop')
          .tarjeta.tarjeta--azul
            .p-4
              h4 Observaciones presentadas
              p.mb-0 La entidad analiza las observaciones presentadas y cita para definir el proceso de audiencia pública de acuerdo al cronograma.
              
            
        .tarjeta-avatar-b.mb-5
          .tarjeta-avatar-b__img
            img(src='@/assets/curso/tema3/img13.svg' alt='AvatarTop')
          .tarjeta.tarjeta--azul
            .p-4
              h4 Audiencia de adjudicación
              p.mb-0 La entidad pública, con antelación, en el SECOP publicará el borrador del acto administrativo de adjudicación, si algún oferente cumple con todos los requisitos del pliego y con las condiciones más favorables en cuanto a costos y calidad, la entidad adjudica el proceso a un oferente, de lo contrario se declara el proceso desierto.




    separador
    #t_3_2.titulo-segundo.color-acento-contenido
      .h2 3.2 Normatividad


    .row.justify-content-center.mb-5
      .col-lg-6.mb-4.mb-lg-0.ontop.pt-lg-3
        
        .bg--blue.neg--right.mb-4(style='background-color: #FFF9E5')
          p.mb-0 Como consecuencia, la contratación tanto pública como privada está regulada y regida por la ley. El conocimiento, al menos básico de esta normatividad, favorece a las personas y empresas, cumplir con lo establecido y alcanzar mejores procesos en la contratación de personal, bienes, servicios, obras, etc.
          
        p.mb-4 Algunas leyes cruciales en la regulación de la contratación en Colombia, son:
          
        .row.justify-content-center.mb-4
          .col-md-10
            ul.lista-ul.ps-md-0
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Ley 80 de 1993 - Modalidades de selección, publicidad, selección objetiva.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Ley 1150 de 2007 - Contratación con recursos públicos.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Ley 1712 de 2014 - Ley de Transparencia.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Ley 1474 – Anticorrupción.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Ley 1150 de 2007 - Eficiencia y Transparencia.
              li 
                i.fas.fa-layer-group.pe-3
                p.mb-0 Ley 4170 – Agencia de contratación pública.
              
      
      .col-10.col-lg-6
        figure(data-aos="fade-left")
          img.mx-auto(src='@/assets/curso/tema3/img14.svg', alt='imagen ambiental', style='width: 610px;')




    separador
    #t_3_3.titulo-segundo.color-acento-contenido
      .h2 3.3 Acuerdos


    .row.justify-content-center.mb-5
      .col-lg-6.mb-4.mb-lg-0.ontop.pt-lg-3
        
        .bg--blue.neg--right.mb-4(style='background-color: #F3F9FF')
          p.mb-0 El acuerdo que rige al sistema de contratación en Colombia se llama “Acuerdo Marco”; al respecto, la página de Colombia Compra Eficiente dice: “El Acuerdo Marco es un instrumento de agregación de demanda. El Acuerdo Marco es un contrato entre Colombia Compra Eficiente, como representante de los compradores públicos y uno o más proveedores para adquirir bienes, obras o servicios que pueden ser estandarizados. 
          
        p.mb-4 El Acuerdo Marco contiene la identificación del bien o servicio, el precio máximo de adquisición, el plazo máximo de entrega, las garantías mínimas y las condiciones en las cuales los compradores pueden vincularse al Acuerdo.
        
      
      .col-10.col-lg-6
        figure(data-aos="fade-left")
          img.mx-auto(src='@/assets/curso/tema3/img15.svg', alt='imagen ambiental', style='width: 610px;')






</template>

<script>
export default {
  name: 'Tema3',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
